import cx from 'classnames';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import ReactivateCTA from '../SharedComponents/ReactivateCTA/ReactivateCTA';
import * as styles from './BoxSubscriptionPanel.module.css';

const BoxSubscriptionPanel = ({ boxSubscription, sysdata, products = [] }) => {
  const renderProductItem = (product, idx) => {
    const hasMultipleVariants = product?.variants?.length > 1;
    const variants = product?.variants ?? [];
    const imageUrl =
      variants[
        hasMultipleVariants
          ? variants.findIndex(
              (variant) => variant.productUuid === product.choiceProductUuid,
            )
          : 0
      ]?.imageUrl;
    return (
      <div key={product?.id} className={styles.productItem}>
        <img alt={product?.name} className={styles.productImage} src={imageUrl} />
        <div className={styles.productDetails}>
          <h4 className={styles.productName}>Choice {idx + 1}</h4>
          <span className={styles.productDescription}>{product?.name}</span>
        </div>
      </div>
    );
  };

  //TODO: Analyze status handling, we decided to omit it for now as per discussed in
  // https://fabfitfun.slack.com/archives/C09AXQRGTDL/p1763579800116639
  // const status = getBeautyBoxOpenStatus(boxSubscription);
  // const isOpen = status === campaignState.OPEN;
  const displayProducts = products.length > 0 ? products : [];
  const hasProducts = displayProducts.length > 0 && boxSubscription.choices.length > 0;
  const boxSlug = `${boxSubscription.brandName.toLowerCase().replace(/\s+/g, '-')}-${boxSubscription.name.toLowerCase().replace(/\s+/g, '-')}`;

  const sortedChoices = boxSubscription.choices?.sort((a, b) => a.choiceNumber - b.choiceNumber);
  // TODO: update this once we have more BE data
  // Slice 4 to ignore last MBB item, which is the freebie item
  const sortedProducts = sortedChoices?.slice(0, 4).map((choice) => {
    const matchedProduct = displayProducts.find((product) => {
      const productMatch = product.productUuid === choice.productUuid;
      const variantMatch = product.variants?.some(
        (variant) => variant.productUuid === choice.productUuid,
      );
      return productMatch || variantMatch;
    });

    return {
      ...(matchedProduct ?? {}), // fallback para no hacer spread de undefined
      choiceProductUuid: choice.productUuid,
    };
  });

  return (
    <>
      <div className={styles.panelContainer}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Beauty Edit Box</h1>
        </div>

        {/* Customizations Section */}
        <div className={styles.customizationsSection}>
          <h2 className={styles.customizationsHeader}>Customizations</h2>
          <p className={styles.description}>
            Thanks for submitting your choices! We’re hard at work processing your box now. You can
            view tracking here as soon as it’s available.
          </p>
          {/* <div className={styles.statusContainer}>
            <div className={styles.status}>
              Status: {status || 'Open'}
              <div
                className={cx(styles.statusLight, {
                  [styles.open]: isOpen,
                })}
              />
            </div>
          </div> */}
        </div>

        {/* Main Container - matches Panel structure */}
        <div className={cx(styles.container, { [styles.centered]: !hasProducts })}>
          <div className={styles.productGridWrapper}>
            {!hasProducts ? (
              <ReactivateCTA
                baseClass="customize"
                title="Customizations are Open!"
                desc="This is where you’ll see your box customizations after you’ve selected them."
                ctaLabel="Customize Now"
                iconClass="fa-hand-holding-box"
                isMobile={sysdata.isMobile}
                isCustomizationFlow
                boxSlug={boxSlug}
              />
            ) : (
              <div className={styles.productGrid}>{sortedProducts.map(renderProductItem)}</div>
            )}
          </div>
        </div>
      </div>
      <div className="hor-rule mar-h-40" />
    </>
  );
};

BoxSubscriptionPanel.propTypes = {
  boxSubscription: shape({}).isRequired,
  sysdata: shape({
    boxData: shape({
      customizeCampaignState: shape({}).isRequired,
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }).isRequired,
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
    isProspect: bool.isRequired,
    revealCallback: func.isRequired,
  }).isRequired,
  products: arrayOf(shape({})),
};

BoxSubscriptionPanel.displayName = 'BoxSubscriptionPanel';

export default BoxSubscriptionPanel;
